<template>
  <img :src="imgVisible ? actualSrc : defaultCover" ref="imgEl" alt="" />
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue'
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import defaultCover from "/assets/default-genre.png";

const props = defineProps({
  cover: {
    type: String,
    default: "",
  },
});
const imgVisible = ref(false)
const imgEl = ref(null)



const actualSrc = props.cover
  ? getObjectStorageFullUrl(props.cover)
  : defaultCover

onMounted(() => {
  if (!imgEl.value) return
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      imgVisible.value = true
      observer.disconnect()
    }
  })
  observer.observe(imgEl.value)
})
</script>
